import { CdkColumnDef, CdkHeaderCell } from '@angular/cdk/table';
import { Directive, ElementRef } from '@angular/core';
import { buildBem } from '../utils/bem';

const bem = buildBem('aui-table');

/** Header cell template container that adds the right classes and role. */
@Directive({
  selector: 'aui-table-header-cell',
  host: {
    class: 'aui-table__header-cell',
    role: 'columnheader',
  },
})
export class TableHeaderCellDirective extends CdkHeaderCell {
  constructor(columnDef: CdkColumnDef, elementRef: ElementRef) {
    super(columnDef, elementRef);
    elementRef.nativeElement.classList.add(
      bem.element(`column-${columnDef.cssClassFriendlyName}`),
    );
  }
}
